<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    maxWidth="75%"
    :title="modal.title"
    :showConfirmButton="false"
    @on-cancel="hide()"
    :closeText="$t('Close')"
  >
    <v-card>
      <v-card-text class="pa-0">
        <v-row justify="center" align="center" v-if="loading">
          <div class="text-center">
            <div>
              <v-progress-circular
                class="my-4"
                :size="50"
                width="5"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <p class="display-1">{{ $t("Loading") }}...</p>
          </div>
        </v-row>
        <base-data-grid
          v-if="!loading"
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          @on-add-click="add"
          :allowExport="false"
          :allowGrouping="false"
          :allowFilter="false"
        >
          <template slot="columnTemplates" slot-scope="row">
            <div v-if="row.data.field == 'target'">
              <span>{{ getTarget(row.data.item) }}</span>
            </div>
          </template>
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
    <SettingsModal :ref="modalKey" @on-item-saved="onItemSaved" />
  </base-modal>
</template>

<script>
import PluginService from "@/services/PluginService";
import WidgetService from "@/services/WidgetService";
import SettingsModal from "@/components/widgets/newsfeed/WidgetNewsfeedSettings";
import Utils from "@/ecm/common/Utils";
import Model from "@/ecm/models/widget/newsfeed/NewsfeedSettings";
import ModelRefreshData from "@/ecm/models/widget/RefreshData";

export default {
  components: {
    SettingsModal,
  },

  data() {
    return {
      grid: {
        key: "newsfeedGrid",
        dataSource: [],
        columns: [
          {
            field: "description",
            caption: this.$t("Description"),
            type: "string",
          },
          {
            field: "target",
            caption: this.$t("Target"),
            type: "string",
            hasTemplate: true,
          },
          {
            field: "user",
            caption: this.$t("User"),
            type: "string",
          },
          {
            field: "startDate",
            caption: this.$t("StartDate"),
            type: "string",
          },
          {
            field: "startTime",
            caption: this.$t("StartTime"),
            type: "string",
          },
          {
            field: "endDate",
            caption: this.$t("EndDate"),
            type: "string",
          },
          {
            field: "endTime",
            caption: this.$t("EndTime"),
            type: "string",
          },
        ],
      },
      modal: {
        title: this.$t("Newsfeed"),
        key: "newsfeedModal",
      },
      targetList: [
        {
          id: "1",
          text: this.$t("Organization"),
        },
        {
          id: "2",
          text: this.$t("Role"),
        },
        {
          id: "3",
          text: this.$t("User"),
        },
      ],
      modalKey: "modalNewsfeedSettings",
      open: false,
      loading: false,
      dbTableName: "widgetNewsfeed",
      newsList: [],
      currentUser: this.$store.getters["account/user"],
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modalKey];
    },
    gridInstance() {
      return this.$refs[this.grid.key];
    },
  },
  methods: {
    getTarget(dto) {
      return this.targetList.find((t) => t.id == dto.target).text;
    },
    loadData() {
      this.loading = true;

      var getDataInternalTableAction = {
        Action: 2, //GetDataInternalTable
        Data: JSON.stringify({
          TableName: this.dbTableName,
        }),
      };

      PluginService.executeAction(getDataInternalTableAction).then((news) => {
        this.loading = false;
        this.newsList = news.map((dto) => {
          return new Model(dto);
        });
        this.grid.dataSource = this.newsList;
      });
    },
    editItem(dto) {
      this.modalInstance.edit(dto);
    },
    deleteItem(dto) {
      this.$confirm(this.$t("ItemDeleteConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          var newsList = Utils.object.toJS(this.newsList);
          this.saveData(newsList, dto.id);
          this.refreshWidgetData(dto);
          Utils.toast.success(this.$t("News") +" "+this.$t("DeletedSuccessfully"));
        }
      });
    },
    show() {
      this.loadData();
      this.open = true;
    },
    hide() {
      this.open = false;
    },
    add() {
      this.modalInstance.new();
    },
    onItemSaved(model) {
      var newsList = Utils.object.toJS(this.newsList);

      newsList = newsList.filter((t) => t.id != model.id);

      newsList.push(model);

      this.saveData(newsList);

      this.refreshWidgetData(model);
    },
    saveData(newsList, idToDelete) {
      let data = newsList.map((t) => {
        if (t.id == idToDelete) {
          return {
            Id: t.id,
            Cells: [],
          };
        } else {
          return {
            Id: t.id,
            Cells: [
              {
                ColumnName: "userName",
                Value: t.id == 0 ? this.currentUser.Surname + ", " + this.currentUser.Name : t.user,
              },
              {
                ColumnName: "description",
                Value: t.description,
              },
              {
                ColumnName: "backgroundColor",
                Value: t.backgroundColor,
              },
              {
                ColumnName: "textColor",
                Value: t.textColor,
              },
              {
                ColumnName: "startDate",
                Value: t.startDate,
              },
              {
                ColumnName: "startTime",
                Value: t.startTime,
              },
              {
                ColumnName: "endDate",
                Value: t.endDate,
              },
              {
                ColumnName: "endTime",
                Value: t.endTime,
              },
              {
                ColumnName: "target",
                Value: t.target,
              },
              {
                ColumnName: "targetValue",
                Value: JSON.stringify(t.targetValue),
              },
              {
                ColumnName: "message",
                Value: t.message,
              },
            ],
          };
        }
      });

      var saveDataInternalTableAction = {
        Action: 3, //SaveDataInternalTable
        Data: JSON.stringify({          
          TableName: this.dbTableName,
          Rows: data,
        }),
      };

      this.loading = true;
      PluginService.executeAction(saveDataInternalTableAction).then(() => {
        this.loading = false;
        this.loadData();
      });
    },
    refreshWidgetData(model) {
      let dto = new ModelRefreshData();
      dto.Method = "refreshNewsfeedData";
      if (model.target == "1") {
        dto.OrganizationId = this.currentUser.OrganizationID;
      }
      if (model.target == "2") {
        dto.RoleIds = model.targetValue;
      }
      if (model.target == "3") {
        dto.UserIds = model.targetValue;
        dto.UserIds.push(this.currentUser.Id);
      }
      WidgetService.refreshData(dto);
    },
  },
};
</script>